{
  "tickets.nav": "الدعم",
  "tickets.title": "الدعم",
  "tickets.subtitle": "ما يطلبه العملاء. الشغل يبقى على اللوحة.",
  "tickets.loadError": "لم نقدر نحمل التذاكر.",
  "tickets.notFound": "لم نقدر نلاقي التذكرة دي.",
  "tickets.empty.title": "ما فيش تذاكر هنا",
  "tickets.empty.open": "أسئلة العملاء الجديدة هتظهر في الصندوق ده.",
  "tickets.empty.unassigned": "كل التذاكر المفتوحة عليها حد.",
  "tickets.empty.mine": "ما فيش حاجة متعيّنة لك دلوقتي.",
  "tickets.empty.resolved": "التذاكر المنتهية هتتجمع هنا.",
  "tickets.empty.thread.title": "اختار تذكرة",
  "tickets.empty.thread.body": "اختار واحدة من القائمة عشان تقرأ المحادثة.",
  "tickets.filter.label": "الصندوق",
  "tickets.filter.unassigned": "من غير مسؤول",
  "tickets.filter.mine": "ليّ",
  "tickets.filter.open": "مفتوحة",
  "tickets.filter.resolved": "منتهية",
  "tickets.status.open": "مفتوحة",
  "tickets.status.in_progress": "قيد التنفيذ",
  "tickets.status.resolved": "منتهية",
  "tickets.court.client": "في انتظار العميل",
  "tickets.court.staff": "في انتظاركم",
  "tickets.unassigned": "من غير مسؤول",
  "tickets.reply": "رد",
  "tickets.reply.placeholder": "اكتب رد العميل هيشوفه.",
  "tickets.reply.send": "إرسال",
  "tickets.reply.sending": "جارٍ الإرسال…",
  "tickets.claim": "استلام",
  "tickets.claiming": "جارٍ الاستلام…",
  "tickets.resolve": "إنهاء",
  "tickets.resolve.confirmTitle": "ننهّي التذكرة؟",
  "tickets.resolve.confirmBody": "العميل هيشوفها منتهية. لو رد تاني هتتفتح من جديد.",
  "tickets.resolve.confirm": "إنهاء التذكرة",
  "tickets.resolve.pending": "جارٍ الإنهاء…",
  "tickets.reopen": "إعادة فتح",
  "tickets.convert": "تحويل لمهمة",
  "tickets.convert.title": "حوّلها لشغل داخلي",
  "tickets.convert.body": "هتنشئ مهمة على اللوحة. العميل هيفضل شايف التذكرة بس.",
  "tickets.convert.project": "المشروع",
  "tickets.convert.projectHint": "مطلوب. اختار مشروع لنفس العميل.",
  "tickets.convert.noProjects": "العميل ما عندوش مشروع لسه. افتح مشروع قبل التحويل.",
  "tickets.convert.confirm": "إنشاء مهمة",
  "tickets.convert.pending": "جارٍ الإنشاء…",
  "tickets.convert.done": "المهمة {reference} على اللوحة.",
  "tickets.closeSuggested": "المهمة المرتبطة خلصت. نقفل التذكرة؟",
  "tickets.closeSuggested.task": "المهمة {reference}",
  "tickets.fromTicket": "من {number}",
  "tickets.reassign": "إعادة تعيين",
  "tickets.reassign.title": "سلّمها لحد تاني",
  "tickets.reassign.body": "التذكرة تفضل بمالك. اختار زميل يقدر يشوف التذاكر.",
  "tickets.reassign.search": "ابحث في الفريق",
  "tickets.reassign.confirm": "إعادة تعيين",
  "tickets.versionConflict": "حد تاني غيّر التذكرة. حدّث الصفحة وجرّب تاني.",
  "tickets.home.title": "دعم العملاء",
  "tickets.home.open": "مفتوح",
  "tickets.home.unassigned": "من غير مسؤول",
  "tickets.home.inProgress": "قيد التنفيذ",
  "tickets.home.caption": "مش محسوبة على إنتاجية المهام.",
  "portal.tickets.nav": "الدعم",
  "portal.tickets.title": "دعمك",
  "portal.tickets.subtitle": "أسئلة وطلبات لـ 404 Creative.",
  "portal.tickets.new": "طلب جديد",
  "portal.tickets.empty.title": "ما فيش طلبات لسه",
  "portal.tickets.empty.body": "ابعت سؤال والفريق هيرد هنا.",
  "portal.tickets.loadError": "لم نقدر نحمل تذاكرك.",
  "portal.tickets.compose.title": "طلب جديد",
  "portal.tickets.compose.subtitle": "الفريق هيشوفها ويرد على الصفحة دي.",
  "portal.tickets.field.title": "الموضوع",
  "portal.tickets.field.body": "رسالتك",
  "portal.tickets.field.project": "المشروع",
  "portal.tickets.field.projectNone": "من غير مشروع محدد",
  "portal.tickets.submit": "إرسال الطلب",
  "portal.tickets.submitting": "جارٍ الإرسال…",
  "portal.tickets.back": "كل الدعم",
  "portal.tickets.reply": "رد",
  "portal.tickets.reply.placeholder": "اكتب متابعة.",
  "portal.tickets.reply.send": "إرسال",
  "portal.tickets.reply.sending": "جارٍ الإرسال…",
  "portal.tickets.compose.error": "لم نقدر نرسل التذكرة. حاول مرة أخرى.",
  "portal.tickets.homeTile": "دعم مفتوح",
  "portal.tickets.notFound": "لم نقدر نلاقي التذكرة دي.",
  "notifications.sentence.ticketOpened": "{actor} فتح التذكرة {target}",
  "notifications.sentence.ticketReplied": "{actor} رد على {target}"
}
